// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const JiraIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="#2684FF"
      d="M46.87 22.66 26.2 2l-2-2L1.56 22.66a1.9 1.9 0 0 0 0 2.68l14.2 14.2L24.21 48l22.66-22.66a1.9 1.9 0 0 0 0-2.68M24.2 31.09 17.11 24l7.1-7.1 7.1 7.1z"
    />
    <path
      fill="url(#jira_svga)"
      d="M24.21 16.9A11.95 11.95 0 0 1 24.16.06L8.63 15.58l8.46 8.45z"
    />
    <path
      fill="url(#jira_svgb)"
      d="m31.33 23.98-7.12 7.11a11.95 11.95 0 0 1 0 16.91l15.57-15.57z"
    />
    <defs>
      <linearGradient
        id="jira_svga"
        x1={21.16}
        x2={13.04}
        y1={11.51}
        y2={19.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="jira_svgb"
        x1={27.35}
        x2={35.46}
        y1={36.41}
        y2={28.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </svg>,
  "Jira",
);
export default JiraIcon;
